<ng-template
  flLoading
  [flLoadingUntil]="flightLog$ | async"
  flLoadingStrategy="overlay"
  flLoadingColor="primary"
>
  <div class="container">
    <fl-view-flight-log
      *ngIf="flightLog$ | async as flightLog"
      [flightLog]="flightLog"
      [flightSummary]="flightSummary$ | async"
    ></fl-view-flight-log>
  </div>
</ng-template>
